import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { trackEvent } from '../utils/analytics';

const WHATSAPP_LINK = "https://wa.me/393921037894?text=Ciao%2C%20vorrei%20un%20preventivo%20gratuito%20per%20uno%20sgombero.%20Posso%20inviarvi%20le%20foto%3F";

export default function FinalCTA() {
  return (
    <section className="relative py-32 bg-maaich-green flex items-center justify-center text-center overflow-hidden">
      {/* Background Texture */}
      <div className="absolute inset-0 bg-black/60 z-0"></div>
      <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1600585154340-be6161a56a0c?q=80&w=2000&auto=format&fit=crop')] bg-cover bg-center mix-blend-overlay opacity-20 z-0"></div>
      
      <div className="container mx-auto px-6 relative z-10">
        <motion.h2 
          className="text-5xl md:text-7xl lg:text-8xl font-display uppercase italic text-white leading-[0.9] mb-8"
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
        >
          IL TUO SGOMBERO POTREBBE COSTARE MOLTO MENO DI QUANTO IMMAGINI.<br/>
          <span className="text-maaich-lime">O NIENTE.</span>
        </motion.h2>

        <motion.p 
          className="text-xl md:text-2xl text-white/80 font-body font-light mb-12 max-w-2xl mx-auto"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2 }}
        >
          Invia alcune foto. Ricevi una valutazione gratuita immediata.
        </motion.p>

        <motion.div 
          className="flex flex-col sm:flex-row justify-center items-center gap-6"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.4 }}
        >
          <a 
            href={WHATSAPP_LINK} 
            target="_blank" 
            rel="noreferrer"
            onClick={() => trackEvent('whatsapp_click', 'cta_finale')}
            className="w-full sm:w-auto bg-maaich-lime hover:bg-white text-maaich-black font-display text-2xl px-12 py-6 uppercase italic transition-all duration-300 flex items-center justify-center gap-3 group shadow-[0_0_40px_rgba(155,203,60,0.3)] hover:shadow-[0_0_60px_rgba(255,255,255,0.4)]"
          >
            <SafeIcon icon={FiIcons.FiMessageCircle} className="text-3xl group-hover:scale-110 transition-transform" />
            Invia Foto su WhatsApp
          </a>
          <a 
            href="tel:+393516488306"
            onClick={() => trackEvent('phone_click', 'cta_finale')}
            className="w-full sm:w-auto border-2 border-white text-white hover:bg-white hover:text-maaich-black font-display text-xl px-10 py-6 uppercase italic transition-colors duration-300 flex items-center justify-center gap-2"
          >
            <SafeIcon icon={FiIcons.FiPhone} className="text-2xl" />
            Chiama Ora
          </a>
        </motion.div>
      </div>
    </section>
  );
}